import { render, staticRenderFns } from "./NoMortgageAlternativesPage.vue?vue&type=template&id=0189341c&scoped=true"
import script from "./NoMortgageAlternativesPage.vue?vue&type=script&lang=js"
export * from "./NoMortgageAlternativesPage.vue?vue&type=script&lang=js"
import style0 from "./NoMortgageAlternativesPage.vue?vue&type=style&index=0&id=0189341c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0189341c",
  null
  
)

export default component.exports